//todo: This pipe can be replaced with Angular's built-in pipe
//Once the investigation has been done for multiple locale support
import { Inject, Pipe, PipeTransform } from '@angular/core';
import { userLanguageToken } from './parse-date.token';
@Pipe({ standalone: true, name: 'parseDate' })
export class ParseDatePipe implements PipeTransform {
  constructor(@Inject(userLanguageToken) private readonly userLanguage: string) {}

  transform(value: string | Date): string {
    if (!value) {
      return '';
    }
    const date = typeof value !== 'string' ? value : new Date(value);
    return Intl.DateTimeFormat(this.userLanguage).format(date);
  }
}
